import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import React from 'react';
import { AccountReceivableInfoTab, useAccountReceivableProvider } from '../../Finance.AccountReceivable.Hooks';

const titleStyle: React.CSSProperties = { fontSize: Theme.FontSize.L, fontWeight: 'bold' };

export default function FinanceAccountReceivableInfoNavigation() {
  const { lang, translate } = getLocales();
  const { pageRouter, selected, commentsApi } = useAccountReceivableProvider();

  return (
    <>
      <div
        data-active={pageRouter.query.infoTab === AccountReceivableInfoTab.INFO ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: AccountReceivableInfoTab.INFO })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.info}</div>
        <div>
          {lang.status}: <b>{translate(selected.statusCode) || lang.noStatusDefined}</b>
        </div>
        <br />
        <div>
          {lang.paymentMethod}: <b>{translate(selected.paymentMethodCode) || selected.paymentMethodCode || 'N/A'}</b>
        </div>
        <br />
        <div>
          {lang.amount}: <b>{selected.amount?.toFixed(2) ?? '0.00'}</b>
        </div>
      </div>
      <div
        data-active={pageRouter.query.infoTab === AccountReceivableInfoTab.DOCUMENTS ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: AccountReceivableInfoTab.DOCUMENTS })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.documents}</div>
        <br />
        {lang.chequeDocument}: {selected.chequeDocument ? '1' : '0'}
        <br />
        {lang.evidenceDocument}: {selected.evidenceDocument ? '1' : '0'}
      </div>
      <div
        data-active={pageRouter.query.infoTab === AccountReceivableInfoTab.NOTES ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: AccountReceivableInfoTab.NOTES })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.notes}</div>
        <br />
        {lang.notes}: {commentsApi?.payload?.count ?? '0'}
      </div>
    </>
  );
}
